import { render, staticRenderFns } from "./html-render.vue?vue&type=template&id=0cdc6caa&"
import script from "./html-render.vue?vue&type=script&lang=js&"
export * from "./html-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports